import React, { useState } from 'react';
import '../../../styles/globals.css'
import { Box, Divider, Paper, Typography } from '@mui/material'
import karmaStyles from '../../../styles/KarmaPool.module.css'
import { useKarmaPoolContext } from '../../../state/KarmaPoolContext';

function DashboardMenuHeaderComponent(props) {

    const karmaContext = useKarmaPoolContext();

    function getAdminMenuItem() {
        if (karmaContext.local != null &&
            karmaContext.local.user != null &&
            karmaContext.local.user.admin) {
            return (
                <>
                    {" / "}
                    <a href={"/karma/dashboard/admin"}>
                        {props.adminEnabled ? <strong>admin</strong> : "admin"}
                    </a>
                </>
            );
        }
        else {
            return null;
        }
    }

    function renderMenu() {
        return (
            <>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "0.25rem" }}>
                    <Divider variant='middle' sx={{ bgcolor: "rgba(221, 221, 221, 0.875)", width: "45%", minWidth: "15rem" }} />
                </Box>
                <p className={karmaStyles.homepageDescription}>

                    <a href={"/karma/dashboard"}>
                        {props.homeEnabled ? <strong>home</strong> : "home"}
                    </a>
                    {" / "}
                    <a href={"/karma/dashboard/social"}>
                        {props.socialEnabled ? <strong>social</strong> : "social"}
                    </a>
                    {" / "}
                    <a href={"/karma/dashboard/causes"}>
                        {props.causesEnabled ? <strong>causes</strong> : "causes"}
                    </a>
                    {" / "}
                    <a href={"/karma/dashboard/pool"}>
                        {props.poolEnabled ? <strong>pool</strong> : "pool"}
                    </a>
                    {getAdminMenuItem()}
                </p>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginBottom: "1.5rem" }}>
                    <Divider variant='middle' sx={{ bgcolor: "rgba(221, 221, 221, 0.875)", width: "45%", minWidth: "15rem" }} />
                </Box>
            </>
        );
    }

    function renderNonMemberMenu() {
        return (
            <>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "0.25rem" }}>
                    <Divider variant='middle' sx={{ bgcolor: "rgba(221, 221, 221, 0.875)", width: "45%", minWidth: "15rem" }} />
                </Box>
                <p className={karmaStyles.homepageDescription}>

                    <a href={"/karma/dashboard"}>
                        {props.homeEnabled ? <strong>home</strong> : "home"}
                    </a>
                    <Box component="span" sx={{ color: "rgba(221, 221, 221, 0.275)" }}>
                        {" / "}
                        {props.socialEnabled ? <strong>social</strong> : "social"}
                        {" / "}
                        {props.causesEnabled ? <strong>causes</strong> : "causes"}
                        {" / "}
                        {props.poolEnabled ? <strong>pool</strong> : "pool"}
                    </Box>
                    {getAdminMenuItem()}
                </p>
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center", marginBottom: "1.5rem" }}>
                    <Divider variant='middle' sx={{ bgcolor: "rgba(221, 221, 221, 0.875)", width: "45%", minWidth: "15rem" }} />
                </Box>
            </>
        );
    }

    return (
        <>
            <Box sx={{ paddingTop: "0.5rem", fontSize: "1.2rem" }}>
                <p> <strong> ⚡ Karma Pool ⚡</strong></p>
                {props.showMenu || props.showMenu === undefined ? (
                    props.nonMember ? renderNonMemberMenu() : renderMenu())
                    : null}
            </Box>
        </>
    );
}



export default DashboardMenuHeaderComponent;